import React from "react";

function GuardLaw() {
    return (
        <div>
            <h2>Law & Legal Responsibilities</h2>
            <p>
                Security guards must understand the legal boundaries of their role. This module covers key legislation, powers of arrest, use of force, and how to operate within the law while protecting people and property.
            </p>

            <h3>Key Legislation</h3>
            <ul>
                <li><strong>Private Security Industry Act 2001</strong> – Governs licensing and conduct</li>
                <li><strong>Criminal Law Act 1967</strong> – Allows use of reasonable force to prevent crime</li>
                <li><strong>Police and Criminal Evidence Act 1984 (PACE)</strong> – Sets out arrest and detention procedures</li>
                <li><strong>Human Rights Act 1998</strong> – Protects individual freedoms and dignity</li>
                <li><strong>Data Protection Act 2018</strong> – Regulates handling of personal information</li>
            </ul>

            <h3>Powers of Arrest</h3>
            <ul>
                <li>Security guards are not police officers</li>
                <li>Can make a <strong>citizen’s arrest</strong> under Section 24A of PACE if:
                    <ul>
                        <li>A person is committing or has committed an indictable offence</li>
                        <li>It is not reasonably practicable for a constable to make the arrest</li>
                        <li>Arrest is necessary to prevent harm, escape, or loss of evidence</li>
                    </ul>
                </li>
                <li>Must use only reasonable force and call police immediately</li>
            </ul>

            <h3>Use of Force</h3>
            <ul>
                <li>Permitted under the <strong>Criminal Law Act 1967</strong></li>
                <li>Force must be <strong>reasonable, necessary, and proportionate</strong></li>
                <li>Excessive force can lead to criminal or civil liability</li>
                <li>Always try to de-escalate before using force</li>
            </ul>

            <h3>Legal Limits</h3>
            <ul>
                <li>No power to search without consent (unless policy allows for bag checks)</li>
                <li>No power to detain beyond what is reasonable</li>
                <li>Must respect privacy, equality, and human rights</li>
                <li>Must not impersonate a police officer</li>
            </ul>

            <h3>Try It Yourself</h3>
            <p>
                <strong>Scenario:</strong> You witness someone stealing from a store. What steps do you take to intervene lawfully and safely?
            </p>

            <h3>Resources</h3>
            <ul>
                <li><a href="https://www.legislation.gov.uk/ukpga/2001/12/contents" target="_blank" rel="noreferrer">Private Security Industry Act 2001</a></li>
                <li><a href="https://www.legislation.gov.uk/ukpga/1967/58/section/3" target="_blank" rel="noreferrer">Criminal Law Act 1967 – Use of Force</a></li>
                <li><a href="https://www.gov.uk/arrested-your-rights" target="_blank" rel="noreferrer">UK Gov – Arrest Rights</a></li>
            </ul>
        </div>
    );
}

export default GuardLaw;
